const UPDATES = [
  {
    date: '07-30',
    label: '最新',
    title: '某顶流明星深夜发文回应近期争议，粉丝评论区炸锅',
    tag: '娱乐圈',
  },
  {
    date: '07-29',
    label: '热门',
    title: '知名企业家涉嫌财务造假被调查，公司股价单日暴跌40%',
    tag: '商业',
  },
  {
    date: '07-29',
    label: '独家',
    title: '热门综艺节目录制现场突发意外，节目组紧急发声明',
    tag: '综艺',
  },
  {
    date: '07-28',
    label: '追踪',
    title: '网红直播翻车事件持续发酵，多家品牌方宣布解约',
    tag: '网红',
  },
  {
    date: '07-28',
    label: '爆料',
    title: '某知名导演新片选角内幕曝光，多位一线演员卷入',
    tag: '影视',
  },
  {
    date: '07-27',
    label: '热议',
    title: '社交平台热搜话题引发全民讨论，阅读量突破10亿',
    tag: '社会',
  },
  {
    date: '07-27',
    label: '快讯',
    title: '国际娱乐大奖提名名单公布，华语作品首次入围主竞赛',
    tag: '国际',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            最新吃瓜快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            51吃瓜官网全网最新动态，每日滚动更新，不错过任何精彩
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {UPDATES.map((item, i) => (
            <div
              key={i}
              className="group flex items-start gap-4 py-4 border-b border-background-200/70 last:border-b-0 cursor-default"
            >
              <div className="flex items-center gap-2 min-w-[100px]">
                <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
                <span
                  className={`text-[10px] font-semibold whitespace-nowrap px-1.5 py-0.5 rounded ${
                    item.label === '最新'
                      ? 'bg-primary-100 text-primary-700'
                      : item.label === '独家'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {item.label}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors leading-relaxed">
                  {item.title}
                </p>
              </div>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}